import React, { useContext, useEffect, useState } from 'react';
import { AppSettings } from '../../config/app-settings';
import { Card, CardBody, CardFooter, CardHeader } from '../../components/other/card/card'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Loader from '../pages/loader'
import { useListVideosQuery } from '../../redux/Api/VideoApiSlice';
import ReusableTable from '../../components/other/ReuseableTable';
import { toast } from 'react-toastify';
import { can } from '../../helpers/auth';
import NoPermission from '../pages/noPermission';

function GetLinksDetails() {

	const [pagination, setPagination] = useState({
		current: 1,
		pageSize: 10
	})

	const [queryParams, setQueryParams] = useState(null)
	const { data: videos, isLoading, error, isFetching } = useListVideosQuery(queryParams, {
		skip: !queryParams
	})

	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			urls: ''
		},

		validationSchema: Yup.object({
			urls: Yup.string().required('Please enter URLs'),
		}),


		onSubmit: (values, { resetForm }) => {
			const urls = values.urls.split('\n');
			let data = urls.join(',')

			if (Object.keys(validation.errors).length > 0) {
				Object.keys(validation.errors).forEach((error) => {
					toast.error(validation.errors[error]);
				});
			}
			if (Object.keys(validation.errors).length === 0) {
				setQueryParams({
					url__in: data,
					expand: ["user", "inserted_by", "campaign"],
					page: pagination.current,
					page_size: pagination.pageSize
				})
				resetForm();
			}
		}

	});

	useEffect(() => {
		if (queryParams) {
			setQueryParams(prevParams => ({
				...prevParams,
				page: pagination.current,
				page_size: pagination.pageSize
			}))
		}
	}, [pagination])

	function formatTimestamp(timestamp) {
		if (timestamp === null) return ""
		const date = new Date(timestamp);

		const year = date.getUTCFullYear();
		const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // months are zero-indexed
		const day = String(date.getUTCDate()).padStart(2, '0');
		const hours = String(date.getUTCHours()).padStart(2, '0');
		const minutes = String(date.getUTCMinutes()).padStart(2, '0');
		const seconds = String(date.getUTCSeconds()).padStart(2, '0');

		return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
	}

	const handleTableChange = paginationInfo => {
		setPagination({
			current: paginationInfo.current,
			pageSize: paginationInfo.pageSize
		})
	}

	const columns = [
		{
			title: "Link",
			dataIndex: "url",
			key: "url",
			sorter: true,
			search: true,
			width: "10%"
		},
		{
			title: 'Campaign',
			dataIndex: 'campaign',
			key: 'campaign.campaign_name',
			sorter: true,
			search: true,
			render: (text, record) => (
				record.campaign.campaign_name
			)
		},
		{
			title: 'Link Type',
			dataIndex: 'link_type',
			key: 'link_type',
			sorter: true,
			search: true,
		},
		{
			title: 'Inserted By',
			dataIndex: 'inserted_by',
			key: 'inserted_by',
			sorter: true,
			search: true,
			render: (text, record) => {
				const { inserted_by } = record;
				return inserted_by ? `${inserted_by.first_name} ${inserted_by.last_name}` : '';
			},
		},
		{
			title: 'Insertion Date',
			dataIndex: 'created_at',
			key: 'created_at',
			render: (text) => (formatTimestamp(text)),
		},
		{
			title: 'Report Date',
			dataIndex: 'report_date',
			key: 'report_date',
			render: (text) => (formatTimestamp(text)),

		},
		{
			title: 'Remove Date',
			dataIndex: 'remove_date',
			key: 'remove_date',
			render: (text) => (formatTimestamp(text)),

		},

	];

	const context = useContext(AppSettings);
	useEffect(() => {
		context.setAppHeaderNone(false);
		context.setAppSidebarNone(false);
		context.setAppContentClass('');
		context.setAppThemePanal(true)

		return function cleanUp() {
			context.setAppHeaderNone(true);
			context.setAppSidebarNone(true);
			context.setAppContentClass('p-0');
			context.setAppThemePanal(false)
			setQueryParams(null);
		};
	}, []);

	useEffect(() => {
		if (error?.data) {
			const errorMessages = Object.values(error.data).flat()
			errorMessages.forEach(message => {
				toast.error(message)
			})
		} else if (error) {
			toast.error("Error while Getting Links.")
		}
	}, [error])

	if (!can("view_videourl")) {
		return <NoPermission />
	}
	return (
		<div>
			<Loader isLoading={isLoading || isFetching} />
			<Card>
				<CardHeader>
					Inquire Links
				</CardHeader>
				<CardBody>
					<div className="mb-3">
						<label htmlFor='urls'>URLs (separated by new lines)</label>
						<br />
						<textarea
							name="urls"
							value={validation.values.urls}
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							placeholder='Enter url'
							style={{ height: "250px", width: '100%', backgroundColor: "transparent", border: '1px solid white', padding: "8px" }}
						/>
						{validation.touched.urls && validation.errors.urls && (
							<p className='text-danger'>{validation.errors.urls}</p>
						)}
					</div>

				</CardBody>
				<CardFooter>
					<div className='flex gap-4'>
						<button type="submit" className="btn btn-outline-theme" onClick={(e) => validation.handleSubmit()}
							disabled={isLoading}
						>
							Submit
						</button>
					</div>
				</CardFooter>
			</Card>

			{videos?.results ? (
				<ReusableTable
					columns={columns}
					data={ videos?.results}
					pagination={{
						current: pagination.current,
						pageSize: pagination.pageSize,
						total: videos?.count,
						showSizeChanger: true
					}}
					onChange={handleTableChange}
				/>
			) : null}
		</div>
	)
}

export default GetLinksDetails;
